// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Bipyq","dragIcon":"SortableItem_dragIcon__337kI","disabled":"SortableItem_disabled__KGYHB"};